import { HTTP } from "@/utils/http";
import Apis from '@/apis/index'
import EventBus from '@/eventbus/index'
import Moment from 'moment'
import * as _ from 'lodash';
import store from "@/store";
import router from '@/router'
import Constants from "@/store/constants";
const uploads = {
  namespaced: true,
  state: {
    transfers: [],
    duplicateMedia: [],
  },
  mutations: {
    addTransfer(state, { file }) {
      console.log("addTransfer" );
      file.progress = 0;
      file.isProcessed = false;
      file.isComplete = false;
      const transfers = [...state.transfers, file]
      state.transfers = transfers;
      if (file.name){
        state.duplicateMedia.push({
          name: file.name.split(".")[0],
          item: null,
          uploadEnd: false,
          isDuplicate: false,
        })
      }

    },
    updateDuplicateMedia(state, { file  , status , res }) {
      console.log("updateDuplicateMedia" );
      console.log(status , res);
      state.duplicateMedia.forEach(item => {
        if (file.name.split(".")[0] === item.name){
          item.uploadEnd = (status === "success" || status === "error");
          if (res){
            item.isDuplicate = res.length > 0 ;
            item.item = {
              title : res[0].additionalInformations.existingTrack.title,
              artist : res[0].additionalInformations.existingTrack.artist,
              creationDate : Moment(res[0].additionalInformations.existingTrack.creationDate).format('DD/MM/YYYY'),
            }  ;
          } else {
            item.isDuplicate = false ;
          }
        }
      })

      state.duplicateMedia.forEach((item, index)=> {

        let checkEndIndex = _.filter(state.duplicateMedia, function(o) { return o.uploadEnd; })
        let checkDuplicateIndex = _.filter(state.duplicateMedia, function(o) { return o.isDuplicate; })

        if (checkEndIndex.length === state.duplicateMedia.length){
          console.log(router)
          EventBus.$emit("loadStationBoxesAfterUp", router.currentRoute.params.stationUid);
          // commit("loadStationBoxes" , this.$route.params.stationUid);
        }

        if (checkEndIndex.length === state.duplicateMedia.length && checkDuplicateIndex.length > 0){
          console.log('duplicate detected');
          EventBus.$emit("mediaDuplicatedDetected", _.filter(state.duplicateMedia, function(o) { return o.isDuplicate; }));
          state.duplicateMedia =[];
        }

        })
    },
    removeTransfer(state, { file }) {
      const idx = state.transfers.indexOf(file)
      const transfers = [...state.transfers]
      transfers.splice(idx, 1)
      state.transfers = transfers
    },
    updateTransferProgress(state, { file, percentComplete, errors }) {
      console.log("updateTransferProgress" );

      file.progress = percentComplete;
      file.errors = errors;
      if (percentComplete >= 100) {


        file.isComplete = true;
      }
      const transfers = [...state.transfers]
      state.transfers = transfers
    },
    setFileProcessed(state, { file }) {
      console.log("setFileProcessed")
      file.isProcessed = true;
      const transfers = [...state.transfers]
      state.transfers = transfers
    },
  },
  actions: {
    performUpload({ commit }, { stationUid, files, trackType  , linkToBoxes , SkipMetadataFetching, SequenceIdentifier ,UploadCount }) {
      console.log("-->", stationUid, files, trackType, linkToBoxes, SkipMetadataFetching, SequenceIdentifier, UploadCount)
      var i = 0;
      let api;
      if (files.length >= Constants.upload.maxMediasForSimpleUploadApi) {
         api =  Apis.library.massUpload;
      } else {
         api = Apis.library.upload;
      }
      // if (files.length >= Constants.upload.maxMediasForSimpleUploadApi) {
      //     console.log(files)
      //   const groupSize= Constants.upload.batchOfMedias;
      //   const subarrays = [];
      //   for (let i = 0; i < files.length; i += groupSize) {
      //     const subarray = files.slice(i, i + groupSize);
      //     subarrays.push(subarray);
      //   }
      //   console.log(subarrays);
      //   subarrays.forEach(filess => {
      //     filess.key = i++ + "_" + new Date().getTime();
      //     // Notify upload change
      //     // const onProgress = e => {
      //     //   const percentComplete = Math.round((e.loaded * 100) / e.total);
      //     //   commit("updateTransferProgress", {
      //     //     filess,
      //     //     percentComplete
      //     //   });
      //     // };
      //
      //     // Build config for upload change notification
      //     // const config = {
      //     //   onUploadProgress: onProgress
      //     // };
      //
      //     // Add Transfer notification tile
      //   //  commit("addTransfer", {filess});
      //
      //     // Build data
      //     const data = new FormData();
      //     data.append("FileType", trackType);
      //     data.append("StationUid", stationUid);
      //     data.append("SkipMetadataFetching", SkipMetadataFetching);
      //     data.append("SequenceIdentifier", SequenceIdentifier);
      //     data.append("UploadCount", UploadCount);
      //     data.append("Files", filess);
      //
      //     if (linkToBoxes) {
      //       data.append("linkToBoxes", linkToBoxes);
      //     }
      //
      //     // Send data
      //     HTTP.post(Apis.library.massupload, data)
      //         .then((response) => {
      //
      //           // commit("setFileProcessed", {filess});
      //           EventBus.$emit("onTrackUploaded", response.data.dataItem);// new Track
      //           EventBus.$emit("reFreshLeftMenu");
      //
      //           // setTimeout(() => {
      //           //   commit("removeTransfer", {filess});
      //           //   commit("updateDuplicateMedia", {
      //           //     filess,
      //           //     status: 'success',
      //           //     res: null
      //           //   });
      //           // }, 5000);
      //         })
      //         .catch(err => {
      //           console.log(err)
      //           // filess.isProcessed = true;
      //           // commit("updateDuplicateMedia", {
      //           //   filess,
      //           //   status: 'error',
      //           //   res: ((err.response || {}).data || {}).errors
      //           // });
      //           // commit("updateTransferProgress", {
      //           //   filess,
      //           //   percentComplete: -1,
      //           //   errors: ((err.response || {}).data || {}).errors
      //           // });
      //           // setTimeout(() => {
      //           //   commit("removeTransfer", {filess});
      //           // }, 10000);
      //         });
      //   })
      // } else {
        files.forEach(file => {
        file.key = i++ + "_" + new Date().getTime();
        //  console.log("uploading file ------->", file);
        // Notify upload change
        const onProgress = e => {
          const percentComplete = Math.round((e.loaded * 100) / e.total);
          commit("updateTransferProgress", {
            file,
            percentComplete
          });
        };

        // Build config for upload change notification
        const config = {
          onUploadProgress: onProgress
        };

        // Add Transfer notification tile
        commit("addTransfer", {file});

        // Build data
        const data = new FormData();
        data.append("FileType", trackType);
        data.append("StationUid", stationUid);
        data.append("SkipMetadataFetching", SkipMetadataFetching);
        data.append("SequenceIdentifier", SequenceIdentifier);
        data.append("UploadCount", UploadCount);
        data.append("File", file);

        if (linkToBoxes) {
          data.append("linkToBoxes", linkToBoxes);
        }

        // Send data
        HTTP.post(api, data, config)
            .then((response) => {

              commit("setFileProcessed", {file});
              EventBus.$emit("onTrackUploaded", response.data.dataItem);// new Track
              EventBus.$emit("reFreshLeftMenu");

              // document.dispatchEvent(new CustomEvent('upload-complete', { detail: file }))
              setTimeout(() => {
                commit("removeTransfer", {file});
                commit("updateDuplicateMedia", {
                  file,
                  status: 'success',
                  res: null
                });
              }, 5000);
            })
            .catch(err => {
              console.log(err)
              file.isProcessed = true;
              commit("updateDuplicateMedia", {
                file,
                status: 'error',
                res: ((err.response || {}).data || {}).errors
              });
              commit("updateTransferProgress", {
                file,
                percentComplete: -1,
                errors: ((err.response || {}).data || {}).errors
              });
              setTimeout(() => {
                commit("removeTransfer", {file});
              }, 10000);
            });
      });
    }

  },
}
export default uploads
